import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError, saveToken } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [msg, setMsg] = useState("Signing you in…");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sessionId });
        if (data.token) saveToken(data.token);
        const role = data.user?.role;
        // Clean the hash BEFORE refresh so that AuthContext.refresh() (which
        // bails when session_id= is present) can actually fetch /auth/me.
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        if (role === "customer") navigate("/customer", { replace: true });
        else if (role === "contractor") navigate("/contractor", { replace: true });
        else navigate("/dashboard", { replace: true });
      } catch (e) {
        setMsg(formatApiError(e));
        setTimeout(() => navigate("/login", { replace: true }), 1500);
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
      <div className="text-[#7A7571] font-body" data-testid="auth-callback-status">{msg}</div>
    </div>
  );
}
